import { withMetadata } from '../min/metadata'

import _isValidNumberForRegion from '../es6/isValidNumberForRegion'

export function isValidNumberForRegion() {
	return withMetadata(_isValidNumberForRegion, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/isValidNumberForRegion.js
// module id = nsM9
// module chunks = 0 1